import React, { useState, useEffect } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  Input,
} from "@mui/material";
import { Form, Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { debounce } from "@syncfusion/ej2-base";
import { Dropzone } from "react-dropzone";
// import "~video-react/dist/video-react.css"; // import css
import { Player } from "video-react";
import { Link } from "react-router-dom";
import {
  getMlmfoutletMaster,
  getoutletListMaster,
  getCompanyListMaster,
  getDeliveryslotListMaster,
  TemplateSaveMaster,
  getLanguageMaster,
  getHeadTypeMaster,
  updateImagebucket,
} from "../../../../apiservicescall/api";
import swal from "sweetalert";
import { Language } from "@material-ui/icons";
import { preventDefault } from "@fullcalendar/core";
import DOMPurify from "dompurify";

import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import RctSectionLoader from "../RctSectionLoader/RctSectionLoader";
import axios from "axios";

const steps = [
  "Enter Template Information",
  "Enter Message Body",
  "Footer content",
];

// Just some styles
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 18,
  },
  preview: {
    // marginTop: 10,
    display: "flex",
    flexDirection: "column",
  },
  image: { maxWidth: "100%", maxHeight: 320 },
  delete: {
    cursor: "pointer",
    padding: 15,
    background: "red",
    color: "white",
    border: "none",
  },
};

const TemplateService = ({ rowData }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [templateName, setTemplateName] = useState("");
  const [language, setLanguage] = useState(0);
  const [languageName, setLanguageName] = useState("");
  const [languageMaster, setLanguageMaster] = useState([]);
  const [category, setCategory] = useState("");
  const [type, setType] = useState(0);
  const [typeName, setTypeName] = useState("");
  const [typeHead, setTypeHead] = useState([]);
  const [message, setMessage] = useState("");
  const [footmessage, setFootMessage] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [address, setAddress] = useState("");
  const [recipientType, setRecipientType] = useState("individual");
  const [mobileNumbers, setMobileNumbers] = useState("");
  const [file, setFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [videoSrc, setVideoSrc] = useState("");
  const [view, setView] = useState(false);
  const [uploadStr, setUploadStr] = useState("");
  const [loader, setLoader] = useState(false);

  const [restarantvalue, setRestarantvalue] = useState([
    { label: "", value: "" },
  ]);

  const [types, setTypes] = useState([{ label: "", value: "" }]);
  const [languageselect, setLanguageselect] = useState();
  const [resName, setResName] = useState("");
  const [resId, setResId] = useState("");
  const [outletMasterlist, setOutletMasterlist] = useState([]);
  const [companyMaster, setCompanyMaster] = useState([]);
  const [outletvalue, setOutletvalue] = useState([{ label: "", value: "" }]);
  const [templateData, setTemplateData] = useState({
    body: "",
    outletName: "",
    footer: "",
    headerText: "",
    headerType: "",
    headerUrl: "",
    headerTypeName: "",
    language: 0,
    languageName: "",
    outletId: 0,
    status: "",
    templateId: 0,
    templateName: "",
  });

  const [templateDetails, setTemplateDetails] = useState({
    templateName: "",
    language: "",
    type: "",
    message: "",
    uploadImage: "",
    uploadVideo: "",
  });

  // const [formData, setFormData] = useState({
  //   templateName: "",
  // });
  const [errors, setErrors] = useState({
    templateName: null,
    language: null,
    type: null,
    message: null,
    uploadImage: null,
    uploadVideo: null,
    latitude: null,
    longitude: null,
  });
  const [formIsValid, setFormIsValid] = useState(false);
  const [error, setError] = useState(false);
  const [errorstep2, setErrorstep2] = useState(false);
  useEffect(() => {
    getcompanyMasterList();
    laugageMaster();
    TypeMaster();

    //console.log("rowData", rowData);
  }, []);

  const getcompanyMasterList = async () => {
    let getoutletList = await getCompanyListMaster();
    let getoutletListValue = getoutletList?.data?.data;
    let companyoutmaster =
      getoutletListValue &&
      getoutletListValue.map(({ compCode, compName }) => ({
        label: compName,
        value: compCode,
      }));

    getoutletMasterList(getoutletListValue[0]?.compCode);
  };

  const getoutletMasterList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data;

    console.log("outletMasterlist", getoutletListValue);
    let companyoutmaster =
      getoutletListValue &&
      getoutletListValue.map(({ outletCode, outletName }) => ({
        label: `${outletCode}-${outletName}`,
        value: outletCode,
      }));
    console.log("companyoutmaster", companyoutmaster);
    setOutletMasterlist(companyoutmaster);
  };

  const laugageMaster = async () => {
    let getmasterList = await getLanguageMaster();

    let getMasterListValue = getmasterList?.data?.data;
    console.log("companyoutmaster", getMasterListValue);
    setLanguageMaster(getMasterListValue);
  };

  const TypeMaster = async () => {
    let getmasterList = await getHeadTypeMaster();

    let getMasterListValue = getmasterList?.data?.data;
    console.log("getHeadTypeMaster", getMasterListValue);
    setTypeHead(getMasterListValue);
  };

  const templateMasterSave = async (key) => {
    console.log("key", key);
    let data = key;
    // data = {
    //   outletCode: restarantvalue.value,
    //   status: "A",
    //   menuId: outletvalue?.value || "",
    //   menuName: menuSubmenuItems?.menuName || "",
    //   subMenuId: menuSubmenuItems?.subMenuId || "",
    //   subMenuName: menuSubmenuItems?.subMenuName || "",
    // };
    let reqformenusubmenu;
    reqformenusubmenu = await TemplateSaveMaster(data);

    console.log("reqformenusubmenu", reqformenusubmenu);

    if (reqformenusubmenu.data.status === true) {
      swal("Success!", "Template Created", "success");

      setActiveStep(0);
      setTemplateName("");
      setLanguage("");
      setType("");
      setMessage("");
      setFootMessage("");
      setResId("");
      setResName("");
      setLanguageName("");
      setTypeName("");
      setRestarantvalue("");
      setLanguageselect("");
      setTypes("");

      setTemplateDetails({});
      setTemplateData({});
    } else {
      swal("Oops", "Error, Please Try Later", "error");
    }
  };

  // const uploadTo = async (event) => {
  //   // if (!selectedFile) {
  //   //   alert('Please select a file.');
  //   //   return;
  //   // }
  //   const selectedFile = event ;
  //   const filename = `videos/${Date.now()}_${selectedFile.name}`;

  //   try {
  //     await Storage.put(filename, selectedFile, {
  //       contentType: selectedFile.type,
  //     });

  //     console.log('Upload to S3 success:', filename);

  //     // After successful upload to S3, make an API call with information about the uploaded file
  //      uploadfilebucket(filename);
  //   } catch (error) {
  //     console.error('Upload to S3 error:', error);
  //   }
  // };

  const videouploadbucket = async (event) => {
    let file = event;
    console.log("object :>> ", event);
    setLoader(true);
    const formData = new FormData();
    formData.append("video", file);

    console.log("event video", formData);

    // formData.append('video', event);

    let reqformenusubmenu;
    reqformenusubmenu = await updateImagebucket(formData);

    if (reqformenusubmenu.data.status === true) {
      console.log("reqformenusubmenu", reqformenusubmenu?.data?.data);
      setUploadStr(reqformenusubmenu.data?.data);
      setLoader(false);
      swal("Success!", "File upload successfully", "success");
    } else {
      setLoader(false);
      swal("Oops", "Error, Please Try Later", "error");
    }
  };

  const uploadfilebucket = async (event) => {
    setLoader(true);
    const formData = new FormData();
    formData.append("file", event);

    let reqformenusubmenu;
    reqformenusubmenu = await updateImagebucket(formData);

    if (reqformenusubmenu.data.status === true) {
      console.log("reqformenusubmenu", reqformenusubmenu.data?.data);
      setUploadStr(reqformenusubmenu?.data?.data);
      setLoader(false);
      swal("Success!", "File upload successfully", "success");
    } else {
      setLoader(false);
      swal("Oops", "Error, Please Try Later", "error");
    }
  };

  const handleChangeVideo = ({ file }) => {
    // var reader = new FileReader();
    // console.log(file)
    // var url = URL.createObjectURL(file);
    setVideoSrc(file);
  };

  const handleDrop = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      // const File = e.target.files[0];
      setSelectedFile(e.target.files[0]);
      videouploadbucket(e.target.files[0]);
    }
  };

  // This function will be triggered when the file field change
  const imageChange = (e) => {
    //const formdata = new FormData(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage(e.target.files[0]);
      uploadfilebucket(e.target.files[0]);
    }
  };

  // This function will be triggered when the "Remove This Image" button is clicked
  const removeSelectedImage = () => {
    setSelectedImage("");
  };

  const onChangeformValidation = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = { ...errors };
    let formIsValidLocal;

    if (key == "templateName") {
      if (!value) {
        addFieldValue = { [key]: null };
        console.log("addFieldValue :>> ", addFieldValue);
        errorsLocal["templateName"] = "Template Name  Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
      // else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["itemName"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        addFieldValue = { [key]: value };
        errorsLocal["templateName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    //setTemplateName(value);

    if (key == "language") {
      if (!value) {
        addFieldValue = { [key]: null };
        console.log("addFieldValue :>> ", addFieldValue);
        errorsLocal["language"] = "Language Name  Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        // {formIsValidLocal? setError(false): setError(true)}
        setFormIsValid(formIsValidLocal);
      }
      // else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["itemName"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        addFieldValue = { [key]: value };
        errorsLocal["language"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        // {formIsValidLocal? setError(false): setError(true)}
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "type") {
      if (!value) {
        addFieldValue = { [key]: null };
        console.log("addFieldValue :>> ", addFieldValue);
        errorsLocal["type"] = "TYPE  Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
      // else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["itemName"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        addFieldValue = { [key]: value };
        errorsLocal["type"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        console.log("formIsValidLocal 2222 :>> ", formIsValidLocal);
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "message") {
      if (!value) {
        addFieldValue = { [key]: null };
        console.log("addFieldValue :>> ", addFieldValue);
        errorsLocal["message"] = "Message Name  Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
      // else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["itemName"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        addFieldValue = { [key]: value };
        errorsLocal["message"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        console.log("formIsValidLocal 2222 :>> ", formIsValidLocal);
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "uploadImage") {
      if (!value) {
        addFieldValue = { [key]: null };
        console.log("addFieldValue :>> ", addFieldValue);
        errorsLocal["uploadImage"] = "Image File  Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
      // else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["itemName"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        addFieldValue = { [key]: value };
        console.log("addFieldValue :>> ", addFieldValue);
        errorsLocal["uploadImage"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        console.log("formIsValidLocal 2222 :>> ", formIsValidLocal);
        setFormIsValid(formIsValidLocal);
        uploadfilebucket(addFieldValue.uploadImage);
      }
    }

    if (key == "uploadVideo") {
      if (!value) {
        addFieldValue = { [key]: null };
        console.log("addFieldValue :>> ", addFieldValue);
        errorsLocal["uploadVideo"] = "Video File  Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
      // else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["itemName"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        addFieldValue = { [key]: value };
        console.log("addFieldValue :>> ", addFieldValue);
        errorsLocal["uploadVideo"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        console.log("formIsValidLocal 2222 :>> ", formIsValidLocal);
        setFormIsValid(formIsValidLocal);
        uploadfilebucket(addFieldValue.uploadVideo);
      }
    }

    const newFormData = { ...templateDetails };
    newFormData[key] = value;
    setTemplateDetails(newFormData);
  };

  // const submitFormData = (e) => {
  //   e.preventDefault();

  //   // checking if value of first name and last name is empty show error else take to step 2
  //   if (
  //     validator.isEmpty(values.firstName) ||
  //     validator.isEmpty(values.lastName)
  //   ) {
  //     setError(true);
  //   } else {
  //     handleNext();
  //   }
  // };
  const handleLatitudeChange = (e) => {
    setLatitude(e.target.value);
  };

  const handleLongitudeChange = (e) => {
    setLongitude(e.target.value);
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const handleNext = () => {
    let isValid = true;

    if (
      activeStep === 0 &&
      (!templateDetails?.templateName ||
        !templateDetails?.language ||
        !templateDetails.type)
    ) {
      let addFieldValue = {};
      let errorsLocal = { ...errors };
      let formIsValidLocal;
      if (!templateDetails?.templateName) {
        errorsLocal["templateName"] = "TemplateName Required";
        setErrors(errorsLocal);
      }
      if (!templateDetails?.language) {
        errorsLocal["language"] = "Language Required";
        setErrors(errorsLocal);
      }
      if (!templateDetails.type) {
        errorsLocal["type"] = "Type Required";
        setErrors(errorsLocal);
      }

      return false;
    } else {
      setError(false);
      let values = templateDetails.type;
      let value = values.split("-");
      let typeid = Number(value?.[0]);
      let typename = value?.[1];
      setType(typeid);
      setTypeName(typename);

      let val = templateDetails.language;
      // if (values) {
      //   errors.username = 'Username is required';
      // }
      let valueh = val.split("-");
      let lgid = Number(valueh?.[0]);
      let lgname = valueh?.[1];
      setLanguage(lgid);
      setLanguageName(lgname);
    }

    // if (activeStep === 1 && type == 1 && !message){

    //     if (!message) {
    //     let errorsLocal = { ...errors };
    //     errorsLocal["message"] = "Message Required";
    //     setErrors(errorsLocal);

    //   }
    //   return false;
    // }

    if (activeStep === 1 && type === 1 && !templateDetails.message) {
      if (!templateDetails.message) {
        let errorsLocal = { ...errors };
        errorsLocal["message"] = "Message Required";
        setErrors(errorsLocal);
      }

      return false;
    }

    if (activeStep === 1 && type === 2 && !templateDetails.uploadImage) {
      if (!templateDetails.uploadImage) {
        let errorsLocal = { ...errors };
        errorsLocal["uploadImage"] = "File Required";
        setErrors(errorsLocal);
      }
      return false;
      //alert("Please upload your image.");
      //return;
    }

    if (activeStep === 1 && type === 3 && !templateDetails.uploadVideo) {
      if (!templateDetails.uploadVideo) {
        let errorsLocal = { ...errors };
        errorsLocal["uploadVideo"] = "File Required";
        setErrors(errorsLocal);
      }
      return false;
      //alert("Please upload your image.");
      //return;
    }
    //  else if(activeStep === 1  && (!selectedImage)||())  {
    //   alert("Please select the image.");
    //   return;
    //   }

    // if (activeStep === 2) {
    //   alert("Please enter the footer Message.");
    //   return;
    // }
    if (activeStep === 1 && type=== 4)  {debugger
      if (!latitude.trim()) {
        setErrors({ ...errors, latitude: "Latitude is required" });
        isValid = false;
      } else {
        setErrors({ ...errors, latitude: null });
      }
  
      if (!longitude.trim()) {
        setErrors({ ...errors, longitude: "Longitude is required" });
        isValid = false;
      } else {
        setErrors({ ...errors, longitude: null });
      }
    }
  
    if (!isValid) {
      return;
    }
  
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);

    if (activeStep === 1) {
      setMessage("");
      setSelectedImage("");
      return;
    }
    if (activeStep === 2) {
      setFootMessage("");
      return;
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const SanitizedText = ({ unsafeText }) => {
    // Sanitize the input using DOMPurify
    const sanitizedText = DOMPurify.sanitize(unsafeText);

    return <div dangerouslySetInnerHTML={{ __html: sanitizedText }} />;
  };

  const handleSave = async () => {
    let data = {
      body: message,
      footer: footmessage,
      headerText: templateDetails?.templateName,
      headerType: type,
      headerTypeName: typeName,
      headerUrl: uploadStr,
      language: language,
      languageName: languageName,
      outletId: resId,
      outletName: resName,
      templateId: "",
      templateName: templateDetails?.templateName,
    };

    try {
      await templateMasterSave(data);
      swal("Good job!", "Template saved successfully!", "success");

      if (onChangeformValidation) {
        onChangeformValidation("templateName", "");
      } else {
        setTemplateDetails((prevDetails) => ({
          ...prevDetails,
          templateName: "",
        }));
      }
    } catch (error) {
      console.error("Failed to save template:", error);
      swal("Oops!", "Failed to save template, please try again!", "error");
    }

    templateMasterSave(data);

    // alert("Template saved successfully!");

    // setActiveStep(0);
    // setTemplateName("");
    // setLanguage("");
    // setType("");
    // setMessage("");
    // setFootMessage("");
    // setResId("");
    // setResName("");
    // setLanguageName("");
    // setTypeName("");
    // setRestarantvalue("");
    // setLanguageselect("");
    // setTypes("");

    // setLatitude("");
    // setLongitude("");
    // setAddress("");
    // setFile(null);
  };

  const handleLanguageChange = (e) => {
    console.log("lauguages", e.target.value);

    let values = e.target.value;
    // if (values) {
    //   errors.username = 'Username is required';
    // }
    let value = values.split("-");
    let lgid = Number(value?.[0]);
    let lgname = value?.[1];
    setLanguageselect(e.target.value);
    setLanguage(lgid);
    setLanguageName(lgname);
  };

  const handleTypeChange = (e) => {
    console.log("Type", e.target.value);
    let values = e.target.value;
    let value = values.split("-");
    let typeid = Number(value?.[0]);
    let typename = value?.[1];
    setTypes(e.target.value);
    setType(typeid);
    setTypeName(typename);
  };

  const handleRestaurantChange = (e) => {
    //console.log("first", e);
    let values = e.target.value;
    let value = values.split("-");
    let resid = Number(value?.[0]);
    let resname = value?.[1];
    console.log("value", value, "resid", resid);

    setRestarantvalue(e.target.value);
    setResId(resid);
    setResName(resname);
  };

  const onViewClose = () => {
    setView(false);
  };

  return (
    <div className="row loaderPostn" id="slotId">
      {loader && <RctSectionLoader />}

      <>
        <div
          className="card-header ovrl-crd-hds "
          style={{ padding: "7px !imporatnt", margin: "0px 15px !important" }}
        >
          <h4 className="card-title">Create Template</h4>
          {/* <Link to={`/Template_list`}>
      <Button
        variant="contained"
        // style={{ marginLeft: "50%" }}
        size="medium"
      >
        Template List
      </Button>
    </Link> */}
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Stepper activeStep={activeStep} alternativeLabel>
                {steps &&
                  steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
              </Stepper>
            </div>
          </div>

          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              height: "52vh",
            }}
          >
            <div className="col-md-4">
              <div>
                <br /> <br />
                {activeStep === 0 && (
                  <div>
                    <FormControl fullWidth variant="outlined" className="mt-0">
                      <InputLabel>Restaurant</InputLabel>
                      <Select
                        value={restarantvalue.value}
                        label="Restaurant"
                        onChange={handleRestaurantChange}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {outletMasterlist &&
                          outletMasterlist.map((make, index) => (
                            <MenuItem key={index} value={make.label}>
                              {make.label}
                            </MenuItem>
                          ))}
                        {/* Add other language options as needed */}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth variant="outlined" className="mt-2">
                      <TextField
                        required
                        label={"Template Name"}
                        style={{ marginTop: "10px" }}
                        fullWidth
                        multiline
                        // rows={4}
                        value={templateDetails?.templateName}
                        onChange={(e) => {
                          let { value } = e.target;
                          if (value.startsWith(" ")) {
                            value = value.substring(1);
                          }
                          // Update the state with the modified value
                          onChangeformValidation("templateName", value);
                        }}
                      />
                      <span style={{ color: "red" }}>
                        {errors["templateName"]}
                      </span>
                    </FormControl>

                    <FormControl fullWidth variant="outlined" className="mt-2">
                      <InputLabel required>Language</InputLabel>
                      <Select
                        value={templateDetails?.language}
                        // onChange={(e) => setLanguage(e.target.value)}
                        onChange={(e) => {
                          onChangeformValidation("language", e.target.value);
                        }}
                        label="Language"
                      >
                        {languageMaster &&
                          languageMaster.map((make, index) => (
                            <MenuItem
                              key={index}
                              value={`${make.lang}-${make.languageName}`}
                            >
                              {make.languageName}
                            </MenuItem>
                          ))}
                        {/* Add other language options as needed */}
                      </Select>
                      <span style={{ color: "red" }}>{errors["language"]}</span>

                      {/* {error ? (
                        <Form.Text style={{ color: "red" }}>
                          This is a required field
                        </Form.Text>
                      ) : (
                        ""
                      )} */}
                    </FormControl>

                    <FormControl fullWidth variant="outlined" className="mt-2">
                      <InputLabel required>Type</InputLabel>
                      <Select
                        value={templateDetails.type}
                        onChange={(e) => {
                          console.log("typer", e.target.value);
                          onChangeformValidation("type", e.target.value);
                        }}
                        label="type"
                      >
                        {typeHead &&
                          typeHead.map((make, index) => (
                            <MenuItem
                              key={index}
                              value={`${make.headerTypeId}-${make.headerTypeName}`}
                            >
                              {make.headerTypeName}
                            </MenuItem>
                          ))}
                      </Select>
                      <span style={{ color: "red" }}>{errors["type"]}</span>
                      {/* {error ? (
                        <Form.Text style={{ color: "red" }}>
                          This is a required field
                        </Form.Text>
                      ) : (
                        ""
                      )} */}
                    </FormControl>
                  </div>
                  //forms end//
                )}
                {activeStep === 1 && (
                  <div className="temp-msg-bdy-inp-fld">
                    {type === 1 && (
                      <FormControl
                        fullWidth
                        variant="outlined"
                        className="mt-3"
                      >
                        <TextField
                          style={{ padding: "0px", height: "20vh" }}
                          label="Message Body"
                          variant="outlined"
                          fullWidth
                          multiline
                          rows={4}
                          value={templateDetails?.message}
                          onChange={(e) => {
                            setMessage(e.target.value);
                            // console.log("typer", e.target.value);
                            onChangeformValidation("message", e.target.value);
                          }}
                          //onChange={(e) => setMessage(e.target.value)}
                        />

                        {/* <span style={{ color: "red" }}>
                          {errors["message"]}
                        </span> */}
                        {/* {errorstep2 ? (
                          <Form.Text style={{ color: "red" }}>
                            This is a required field
                          </Form.Text>
                        ) : (
                          ""
                        )} */}
                      </FormControl>
                    )}

                    {
                      type === 2 && (
                        <div className="row tmp-img-inp-fld-hg">
                          <FormControl
                            fullWidth
                            variant="outlined"
                            className="mt-3"
                          >
                            <div className="">
                              {/* <div style={styles.container}> */}
                              <input
                                accept="image/*"
                                type="file"
                                // onChange={imageChange}
                                onChange={(e) => {
                                  // console.log("typer", e.target.value);
                                  onChangeformValidation(
                                    "uploadImage",
                                    e.target.files[0]
                                  );
                                }}
                              />
                            </div>
                            <span style={{ color: "red" }}>
                              {errors["uploadImage"]}
                            </span>
                          </FormControl>
                          <div className="col mt-3 ps-0">
                            <TextField
                              label="Enter Text"
                              variant="outlined"
                              multiline
                              rows={4}
                              value={message}
                              onChange={(e) => {
                                let { value } = e.target;
                                if (value.startsWith(" ")) {
                                  value = value.substring(1);
                                }
                                setMessage(value);
                              }}
                            />
                          </div>{" "}
                        </div>
                      )

                      // (
                      //   <Input
                      //     type="file"
                      //     accept="image/*"
                      //     onChange={handleFileChange}
                      //     className="mt-3"
                      //   />
                      // )
                    }

                    {type === 3 && (
                      <div className="row">
                        <div className="">
                          <Container>
                            <Row>
                              <Col md={6}>
                                <Form>
                                  <Form.Group
                                    controlId="formFile"
                                    className="mb-3"
                                  >
                                    <Form.Label>
                                      Choose a video file:
                                    </Form.Label>
                                    <Form.Control
                                      type="file"
                                      accept="video/*"
                                      // onChange={handleDrop}
                                      onChange={(e) => {
                                        // console.log("typer", e.target.value);
                                        onChangeformValidation(
                                          "uploadVideo",
                                          e.target.files[0]
                                        );
                                      }}
                                    />
                                  </Form.Group>
                                  <span style={{ color: "red" }}>
                                    {errors["uploadVideo"]}
                                  </span>
                                </Form>
                              </Col>
                            </Row>
                          </Container>
                        </div>
                        <div className="col tmp-img-inp-fld-hg ps-3 ms-4">
                          <TextField
                            label="Enter Text"
                            variant="outlined"
                            //fullWidth
                            multiline
                            rows={4}
                            value={message}
                            onChange={(e) => {
                              let { value } = e.target;
                              if (value.startsWith(" ")) {
                                value = value.substring(1);
                              }
                              setMessage(value);
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {type === 4 && (
                      <div>
                        <TextField
                          label="Latitude"
                          variant="outlined"
                          fullWidth
                          value={latitude}
                          onChange={(e) => {
                            let { value } = e.target;
                            if (value.startsWith(" ")) {
                              value = value.substring(1);
                            }
                            setLatitude(value);
                          }}
                          className="mt-3"
                          error={errors.latitude} // Assuming errors.latitude is a boolean indicating if there's an error
                          helperText={errors.latitude && "Latitude is required"}
                        />
                        <TextField
                          label="Longitude"
                          variant="outlined"
                          fullWidth
                          value={longitude}
                          onChange={(e) => {
                            let { value } = e.target;
                            if (value.startsWith(" ")) {
                              value = value.substring(1);
                            }
                            setLongitude(value);
                          }}
                          className="mt-3"
                          error={errors.longitude} // Assuming errors.longitude is a boolean indicating if there's an error
                          helperText={
                            errors.longitude && "Longitude is required"
                          }
                        />
                        <TextField
                          label="Address"
                          variant="outlined"
                          fullWidth
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          className="mt-3"
                        />
                      </div>
                    )}
                  </div>
                )}
                {activeStep === 2 && (
                  <div className="temp-msg-bdy-inp-fld">
                    <TextField
                      label="Message Footer"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      value={footmessage}
                      onChange={(e) => {
                        let { value } = e.target;
                        if (value.startsWith(" ")) {
                          value = value.substring(1);
                        }
                        setFootMessage(value);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-4 rght-prvw">
              <Typography
                variant="h5"
                style={{
                  textAlign: "center",
                  marginBottom: "8px",
                  wordBreak: "break-all",
                }}
              >
                Preview{" "}
              </Typography>

              <Card style={{ backgroundColor: "azure" }}>
                <CardContent>
                  <div>
                    {type === 2 && (
                      <div style={styles.container}>
                        {templateDetails?.uploadImage && (
                          <div>
                            <img
                              src={URL.createObjectURL(
                                templateDetails?.uploadImage
                              )}
                              width="25%"
                              height="100%"
                              style={{
                                marginLeft: "5px",
                                marginBottom: "5px",
                                marginLeft: "2",
                              }}
                              alt="Thumb"
                            />
                          </div>
                        )}
                      </div>
                    )}

                    {type === 3 && (
                      <div style={styles.container}>
                        {templateDetails?.uploadVideo && (
                          <div>
                            <video width="20%" controls>
                              <source
                                src={URL.createObjectURL(
                                  templateDetails?.uploadVideo
                                )}
                                type="video/mp4"
                              />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        )}
                      </div>
                    )}

                    {templateDetails?.templateName && (
                      <Typography
                        variant="h6"
                        style={{ marginBottom: "8px", wordBreak: "break-all" }}
                      >
                        {templateDetails.templateName}
                      </Typography>
                    )}

                    {message && (
                      <Typography
                        variant="body1"
                        style={{ marginBottom: "8px", wordBreak: "break-word" }}
                      >
                        {message}
                      </Typography>
                    )}

                    {footmessage && (
                      <Typography variant="body2">{footmessage}</Typography>
                    )}

                    {type === 4 && (
                      <div>
                        <Typography variant="subtitle1">
                          Latitude: {latitude}
                        </Typography>
                        <Typography variant="subtitle1">
                          Longitude: {longitude}
                        </Typography>
                        <Typography variant="subtitle1">
                          Address: {address}
                        </Typography>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* {activeStep !== steps.length && (
              <div>
                <Button className="bck-btn"
                  onClick={handleBack}
                  sx={{ marginRight: 1 }}
                  disabled={activeStep === 0}
                >
                  Back
                </Button>
               
              </div>
            )} */}

          {activeStep !== steps.length && (
            <Row className="mt-2 mb-2">
              <Col className="brdcst-bck-btn" style={{ paddingLeft: "33px" }}>
                <Button
                  onClick={handleBack}
                  sx={{ marginRight: 1 }}
                  disabled={activeStep === 0}
                >
                  Back
                </Button>
              </Col>
              <Col className="brdcst-nxt-btn">
                <Button
                  style={{ marginLeft: "75%" }}
                  variant="contained"
                  disabled={
                    (activeStep === 0 && (!templateDetails?.templateName || !templateDetails?.language || !templateDetails.type)) ||
                    (activeStep === 1 && ((type === 1 && !templateDetails.message) || (type === 2 && !templateDetails.uploadImage) || (type === 3 && !templateDetails.uploadVideo))) ||
                    (activeStep === 4 && (!latitude.trim() || !longitude.trim()))
                  }
                  onClick={handleNext}
                >
                  {activeStep === steps.length - 1 ? "Submit" : "Next"}
                </Button>
              </Col>
            </Row>
          )}
          {activeStep === steps.length && (
            <div className="row">
              <div
                className="col-12 mb-2"
                style={{
                  display: "flex",
                  justifyContent: "end",
                  paddingRight: "33px",
                }}
              >
                <Button
                  style={{
                    marginLeft: "70%",
                  }}
                  variant="contained"
                  onClick={handleSave}
                >
                  Save Template
                </Button>
              </div>
            </div>
          )}

          {/* <div className="col-md-10" style={{display:"flex",justifyContent:"end",paddingRight:"46px"}}>
          {activeStep === steps.length && (
              <Button variant="contained" onClick={handleSave}>
                Save Template
              </Button>
            )}
              
          </div> */}
        </div>

        <Modal
          isOpen={view}
          toggle={() => onViewClose()}
          /*  size={"lg"} */
          style={{ maxWidth: "900px" }}
          backdrop="static"
        >
          <ModalHeader className="popup-header">Template View</ModalHeader>
          <ModalBody className="time-edit-con">
            <div className="row" style={{}}>
              {view == true && <TemplateService rowData={rowData} />}
            </div>
          </ModalBody>
          <ModalFooter>
            <>
              {/* <Button variant="primary"
                // disabled={!menuSubmenuItems?.subMenuName}
                onClick={() => { saveMenuSubmenu("Maninmenu") }} >Save</Button> */}

              <Button
                variant="danger light"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  //  setSubMenuModal(false),
                  onViewClose();
                }}
              >
                Close
              </Button>
            </>
          </ModalFooter>
        </Modal>
      </>
    </div>
  );
};

export default TemplateService;
